module.exports = __webpack_public_path__ + "static/media/logout-mobile.84e6426b.svg";